export enum ImageTypes {
  Logo = "LOGO",
  LogoAlternate = "LOGO_ALTERNATE",
  LogoBackground = "LOGO_BACKGROUND",
  PersonHead = "PERSON_HEAD",
  PersonWaist = "PERSON_WAIST",
  PersonPose = "PERSON_POSE",
  TeamPhoto = "TEAM_PHOTO",
  Uniform = "UNIFORM",
  UniformItem = "UNIFORM_ITEM",
}
